export class ImageClassifierPrediction {
  public constructor(private labels: string[], private confidences: number[]) {}

  public get highest(): { label: string; confidence: number } {
    const maxIndex: number = this.confidences.indexOf(Math.max.apply(null, this.confidences));
    return { label: this.labels[maxIndex], confidence: this.confidences[maxIndex] };
  }
}
